import { CirclePlaySolidIcon, VideoConferenceIcon } from '@execonline-inc/execonline-ui';
import { ProgramInstanceKind } from '../../../ProgramStore/Types';
import { T } from '../../../Translations';

interface Props {
  programInstanceKind: ProgramInstanceKind;
}

function ProgramFormatLabel({ programInstanceKind }: Props) {
  switch (programInstanceKind) {
    case 'scheduled':
      return (
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary">
          <VideoConferenceIcon size="sm" color="inherit" />
          <T kind="Professor-Led" />
        </span>
      );
    case 'on-demand':
      return (
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-500">
          <CirclePlaySolidIcon size="sm" color="inherit" />
          <T kind="On-Demand" />
        </span>
      );
  }
}

export default ProgramFormatLabel;
